import React from 'react';
import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import Date from "./Cells/Date";
import Number from "./Cells/Number";
import Number2 from "./Cells/Number2";
import ContactName from "bukku/components/Columns/Reports/Common/ContactName";
import Description from "./Cells/Description";
import Title from "./Cells/Title";
import Amount from "./Cells/Amount";
import Cost from "./Cells/Cost";
import {AmountTdWidth} from "../../../Table/Common/AmountTd";
import FormatNumber from '../../../FormatNumber';
import { LockIcon } from '../../../Access/common/LockIcon';

function getColumns(props) {
    const { hideInventoryCosting, companyCurrencyCode = '' } = props;

    return [
        {
            title: t`Date`,
            key: 'date',
            cellRenderer: ({ rowData: record }) => <Date record={record} />,
            width: 0,
            flexGrow: 16,
        },
        {
            title: t`No.`,
            key: 'number',
            cellRenderer: ({ rowData: record }) => <Number record={record} />,
            width: 0,
            flexGrow: 16,
        },
        {
            title: t`Customer`,
            key: 'contact_name',
            cellRenderer: ({ rowData: record }) => (
                <ContactName
                    contact_id={record.contact_id}
                    contact_name={record.contact_name}
                    contact_code={record.contact_code}
                />
            ),
            width: 0,
            flexGrow: 20,
        },
        {
            title: t`Contact Code`,
            key: 'contact_code',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData: record }) => record.contact_code,
        },
        {
            title: t`Reference No.`,
            key: 'number2',
            cellRenderer: ({ rowData: record }) => <Number2 record={record} />,
            width: 0,
            flexGrow: 15,
        },
        {
            title: t`Title`,
            key: 'title',
            cellRenderer: ({ rowData: record }) => <Title record={record} />,
            width: 0,
            flexGrow: 15,
        },
        {
            title: t`Description`,
            key: 'description',
            cellRenderer: ({ rowData: record }) => <Description record={record} />,
            width: 0,
            flexGrow: 18,
        },
        {
            title: `${t`Amount`} ${companyCurrencyCode}`,
            key: 'base_amount',
            align: 'right',
            cellRenderer: ({ rowData: record }) => <Amount
                record={record}
                hideInventoryCosting={hideInventoryCosting}
            />,
            width: AmountTdWidth,
        },
        {
            title: `${t`Cost`} ${companyCurrencyCode}`,
            key: 'base_cost_amount',
            align: 'right',
            cellRenderer: ({ rowData: record }) => <Cost
                record={record}
                hideInventoryCosting={hideInventoryCosting}
            />,
            width: AmountTdWidth,
        },
        {
            title: t`Margin %`,
            key: 'margin_pct',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => {
                if (hideInventoryCosting)
                    return <LockIcon className="grey" />;

                if (record.margin_pct)
                    return <FormatNumber amount={record.margin_pct} />;
                return '-';
            },
        },
    ];
}

export default {
    storageKey: StorageKey.report_profit_summary,
    getReportLabel: () => t`Profit Summary`,
    required: [
        'date',
        'base_amount',
        'base_cost_amount',
    ],
    defaulto: [
        'number',
        'contact_name',
        'description',
    ],
    getColumns,
};
